import { RootState } from "@circuitry-ai/doc-data";
import { Skeleton } from "@nextui-org/react";
import { useSelector } from "react-redux";

interface ChatSkeletonLoaderProps {
    isLoading?: boolean;
    isStreamingInProgress?: boolean;
}

const ChatSkeletonLoader = (props: Readonly<ChatSkeletonLoaderProps>) => {

    const { isLoading = false, isStreamingInProgress = false } = props;
    const { isSocketLoading } = useSelector((state: RootState) => state.chatAdvisorSliceReducer);

    // Don't show the skeleton loader if streaming is in progress
    const shouldShowLoader = (isLoading || isSocketLoading) && !isStreamingInProgress;

    return (shouldShowLoader && (
        <div data-testid="chat-skeleton-container" className="space-y-1 flex flex-col justify-start items-start py-3 w-full">
            <Skeleton data-testid="skeleton-item" className="w-3/5 rounded-lg">
                <div className="h-3 w-3/5 rounded-lg bg-default-200"></div>
            </Skeleton>
            <Skeleton data-testid="skeleton-item" className="w-4/5 rounded-lg">
                <div className="h-3 w-4/5 rounded-lg bg-default-200"></div>
            </Skeleton>
            <Skeleton data-testid="skeleton-item" className="w-2/5 rounded-lg">
                <div className="h-3 w-2/5 rounded-lg bg-default-300"></div>
            </Skeleton>
        </div>
    ));
};

export { ChatSkeletonLoader };